<template>
    <div id="form-login">
        <div id="login" class="form absolute" v-if="!failToEnter" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm, xs:$vuetify.breakpoint.xs}">
            <a href="https://tasko.xyz" class="d-block">
                <img width="70px" height="70px" src="./../../assets/images/auth/Group 593.png" class="d-block">
                <img  class="mt-4 mx-auto d-block" width="60.9px" height="16.99px" src="./../../assets/images/auth/Tasko.png">
            </a>
            <div class="form-group mt-9 w-100" v-autofill-catch>
                <div class="mt-12 roboto-normal-20 clr-black-28 text-center">Войти в аккаунт</div>
                <div class="info-text ml-10 ml-lg-12 mt-6" v-if="activated">
                    Ваш аккаунт успешно активирован!
                </div>
                <input 
                    class="mt-10 mx-auto d-block input-auth" 
                    placeholder="Укажите адрес электронной почты" 
                    v-model="loginEmail"
                    :class="{invalid: errorEmailAndPassword}"
                >
                <input 
                    type="password" 
                    class="mt-2 mx-auto d-block input-auth" 
                    placeholder="Введите пароль" 
                    v-model="loginPassword"
                    :class="{invalid: errorEmailAndPassword}"
                >
                <div class="input-error roboto-normal-14 ml-10 mt-3" v-if="errorEmailAndPassword">Вы ввели неверные данные.</div>
                <button 
                    class="py-3 mt-8 text-capitalize button-auth"
                    :class="{submit: showActiveSubmit, xs:$vuetify.breakpoint.xs}"
                    :disabled="!showActiveSubmit || pending"
                    @click="login()"
                >Войти
                </button>
                <!-- <div class="flex-center mt-12 px-11">
                    <div class="roboto-normal-16 clr-black-66">или войти через:</div>
                    <img class="ml-12 pl-5 pointer" src="./../../assets/images/auth/Google.png">
                    <img class="ml-5 pointer" src="./../../assets/images/auth/Vk.png">
                    <img class="ml-5 pointer" src="./../../assets/images/auth/Facebook.png">
                </div> -->
                <div class="mt-9 border mx-auto" :class="{xs:$vuetify.breakpoint.xs}"></div>
                <div class="flex-center-between justify-center mt-8 mb-8 ml-10 mr-11 clr-blue pointer roboto-normal-16 align-center">
                    <!-- <div @click="toFailToEnter()">Не удается войти?</div> -->
                    <div @click="toRegister()">Зарегистрировать аккаунт</div>
                </div>
            </div>
            <div class="mt-10 clr-blue pointer roboto-normal-14" @click="toDataPolitic()">Политика конфиденциальности</div>
            <div class="mt-8 clr-blue pointer roboto-normal-14" @click="toPersonalAgreement()">Условия пользования</div>
        </div>
        <div id="fail" class="form absolute" v-if="failToEnter && !support" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm, xs:$vuetify.breakpoint.xs}">
            <img width="70px" height="70px" src="./../../assets/images/auth/Group 593.png">
            <img  class="mt-6" width="60.9px" height="16.99px" src="./../../assets/images/auth/Tasko.png">
            <div class="form-group mt-9">
                <div class="mt-12 roboto-normal-20 clr-black-28 text-center">Не удается войти?</div>
                <div class="mt-9 roboto-normal-16 clr-black-66 text-center">Мы отправим ссылку на восстановление доступа:</div>
                <input class="mt-10 mx-auto d-block input-auth" placeholder="Укажите адрес электронной почты">
                <button class="py-3 mt-8 text-capitalize button-auth submit" :class="{xs:$vuetify.breakpoint.xs}">Отправить</button>
                <div class="mt-9 border mx-auto" :class="{xs:$vuetify.breakpoint.xs}"></div>
                <div class="mt-6 mb-12 clr-blue pointer text-center roboto-normal-16" @click="toLogin()">Вернуться к входу в систему</div>
            </div>
            <div class="mt-9 clr-blue pointer roboto-normal-14" @click="toSupport()">Связаться с поддержкой</div>
        </div>
        <div id="support" class="form absolute" v-if="support" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm, xs:$vuetify.breakpoint.xs}">
            <img width="70px" height="70px" src="./../../assets/images/auth/Group 593.png">
            <img  class="mt-6" width="60.9px" height="16.99px" src="./../../assets/images/auth/Tasko.png">
            <div class="form-group mt-9">
                <div class="mt-12 roboto-normal-20 clr-black-28 text-center">Связаться с поддержкой</div>
                <input class="mt-8 mx-auto d-block input-auth" placeholder="Укажите адрес электронной почты">
                <input class="mt-2 mx-auto d-block input-auth support" placeholder="Опишите, какая возникла проблема">
                <button class="py-3 mt-6 text-capitalize button-auth submit" :class="{xs:$vuetify.breakpoint.xs}">Отправить</button>
                <div class="mt-9 border mx-auto" :class="{xs:$vuetify.breakpoint.xs}"></div>
                <div class="mt-6 mb-12 clr-blue pointer text-center roboto-normal-16" @click="toLoginFromSupport()">Вернуться к входу в систему</div>
            </div>
        </div>
        <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
    name: 'Login',
    data(){
        return {
            pending: false,
            activated: false,
            loginEmail: '',
            loginPassword: '',
            errorEmailAndPassword: false,
            failToEnter: false,
            support: false,
            localHost: window.location.origin,
            message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
            linkLabel: "Узнать подробнее",   
            buttonLabel: "Ясно"
        }
    },
    computed: {
        ...mapGetters(['learned']),
        showActiveSubmit() {
            return this.loginEmail && this.loginPassword // || !this.errorEmailAndPassword || this.activated ? true : false
        }
    },
    methods: {
        ...mapActions(['logIn', 'getThemes', 'getFeeds', 'getProfile', 'activate']),
        ...mapMutations(['SET_ERROR']), 
        async login() {
            try {
                this.pending = true
                this.showActiveSubmit ? this.errorEmailAndPassword = false : this.errorEmailAndPassword = true
                if(this.showActiveSubmit) {
                    await this.logIn({email: this.loginEmail, password: this.loginPassword})
                    await this.getProfile()
                    if (this.learned) {
                        await this.$router.push('/')
                        await this.getThemes({current: true})
                        await this.getFeeds({current: true}) 
                    } else {
                        this.$router.push('/learn')
                    }
                }
                this.pending = false
            } catch(e){
                this.pending = false
                this.SET_ERROR('Ошибка авторизации: ' + e)
            }
        },
        toFailToEnter() {
            this.failToEnter = true
        },
        toRegister() {
            this.$router.push('/register')
        },
        toLogin() {
            this.failToEnter = false
        },
        toSupport() {
            this.support = true
        },
        toLoginFromSupport() {
            this.support = false
            this.failToEnter = false
        },
        toDataPolitic() {
            window.location=`${this.localHost}/terms/data_politic_en.html`
        },
        toPersonalAgreement() {
            window.location=`${this.localHost}/terms/personal_agreement_en.html`
        },
        toUserAgreement() {
            window.location=`${this.localHost}/terms/user_agreement_en.html`
        },
        toLicense() {
            window.location=`${this.localHost}/terms/license_en.html`
        }
    },
    async created(){
        if(this.$route.query.token) {
            await this.activate({token: this.$route.query.token})
            this.activated = true
        }
    }
}
</script>

<style lang="scss" scoped>
    .info-text{
        color: #7afb8f;
    }
#form-login {
    input::placeholder {
        color:#BEBEBE;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
    } 
    input:focus::-webkit-input-placeholder {
        color:#666666;
    }
    .border {
        border: 1px solid #D6D6D6;
        max-width: 80%;
    }
    #support {
        input.support {
            height: 100px;
            padding: 19px 90px 106px 18px
        }
    }
}
</style>